module.exports = __webpack_public_path__ + "img/sashimi_tempura.f9993733.jpg";